var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-footer"},[_c('div',{staticClass:"app-footer__inner"},[_c('div',{staticClass:"app-footer-left"},[_c('FooterDots')],1),_vm._v(" "),_c('div',{staticClass:"app-footer-right"},[_c('FooterMenu')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7af3b437","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Layout/Components/Footer.vue
// module id = null
// module chunks = 